module.exports = __webpack_public_path__ + "img/header-auth-space.1e768400.svg";